import { createContext, ReactNode, useContext, useMemo } from 'react';

export type DashboardFilter = {
  associationId?: number;
  districtId?: number;
};

const DashboardFilterContext = createContext<DashboardFilter>({});

export const useDashboardFilter = (): DashboardFilter => useContext(DashboardFilterContext);

type Props = {
  value: DashboardFilter;
  children: ReactNode;
};

export const DashboardFilterProvider = ({ value, children }: Props) => {
  const memoValue = useMemo(() => value, [value]);
  return <DashboardFilterContext.Provider value={memoValue}>{children}</DashboardFilterContext.Provider>;
};
